import React from 'react';

import Description from '../containers/metadata/description';
import CommentTabs from '../containers/comments/commenttabs';
import NewComment from '../containers/comments/newcomment';
import Comments from '../containers/comments/comments';
import Sidebar from '../containers/metadata/sidebar';
import Togglable from './togglable';

const DisabledComments = Togglable(() => (
	<div class="alert alert-dark mb-3 mb-lg-4">
		<p class="mb-0"><i aria-hidden="true" class="material-icons">info_outline</i> Comments have been disabled for this item</p>
	</div>
))

const CommentBlock = Togglable(({  }) => (
	<>
		<h2 className="text-black-secondary typography-body-2">Comments</h2>
		<CommentTabs />
		<div className="tab-content">
			<div className="tab-pane active fade show" role="tabpanel">
				<NewComment />
				<Comments />
			</div>
		</div>
	</>
))

const Metadata = ({ show_metadata, allow_comments }) => (
	<div id="div-main">
		<div className="container">
			<div className="row">
				<div className="col">
					<Description device="desktop" />
					<CommentBlock visible={allow_comments} />
					<DisabledComments visible={!allow_comments} />
				</div>

				<Sidebar />
			</div>
		</div>
	</div>
)

export default Metadata;